var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_1647)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.555 3.84301L20.157 7.44501C20.4242 7.71217 20.6362 8.02934 20.7808 8.37843C20.9254 8.72751 20.9998 9.10166 20.9998 9.47951C20.9998 9.85736 20.9254 10.2315 20.7808 10.5806C20.6362 10.9297 20.4242 11.2468 20.157 11.514L17.514 14.157C17.2468 14.4242 16.9297 14.6362 16.5806 14.7808C16.2315 14.9254 15.8574 14.9998 15.4795 14.9998C15.1017 14.9998 14.7275 14.9254 14.3784 14.7808C14.0293 14.6362 13.7122 14.4242 13.445 14.157L13.144 13.856L6.586 20.414C6.25372 20.7462 5.81508 20.9509 5.347 20.992L5.172 21H4C3.75507 21 3.51866 20.9101 3.33563 20.7473C3.15259 20.5845 3.03566 20.3603 3.007 20.117L3 20V18.828C3.00011 18.3585 3.16543 17.9039 3.467 17.544L3.586 17.414L4 17H6V15H8V13L10.144 10.856L9.843 10.555C9.5758 10.2878 9.36384 9.97067 9.21923 9.62159C9.07462 9.27251 9.00019 8.89836 9.00019 8.52051C9.00019 8.14266 9.07462 7.76851 9.21923 7.41943C9.36384 7.07034 9.5758 6.75317 9.843 6.48601L12.486 3.84301C12.7532 3.57581 13.0703 3.36385 13.4194 3.21924C13.7685 3.07463 14.1427 3.0002 14.5205 3.0002C14.8984 3.0002 15.2725 3.07463 15.6216 3.21924C15.9707 3.36385 16.2878 3.57581 16.555 3.84301Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9H15.01",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_1647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.2efd8402a46d43ec577d18c52313cf83.svg";
export { ForwardRef as ReactComponent };